import React, { FC } from "react";

import {
  useApisMembersKnowledgeInsightPostCommentsLikedEmployeesIndex,
  useArray,
} from "~/hooks";

import { ReactedEmployeeType } from "~/domains";

import { ReactedEmployeesModal } from "~/ui";

type PropsType = {
  knowledgeInsightPostCommentId: string;
  onClose: () => void;
};

export const KnowledgeInsightPostCommentsLikedEmployeesModal: FC<PropsType> = ({
  knowledgeInsightPostCommentId,
  onClose,
}: PropsType) => {
  const { items, setItems } = useArray<ReactedEmployeeType>([]);
  const { fetchNextPage, hasNextPage, isLoading } =
    useApisMembersKnowledgeInsightPostCommentsLikedEmployeesIndex({
      knowledgeInsightPostCommentId,
      config: {
        onSuccess: (data) => {
          setItems(
            data.pages
              .map((page) => page.knowledgeInsightPostCommentLikes)
              .flat(),
          );
        },
      },
    });
  return (
    <ReactedEmployeesModal
      headerTitle="いいねしたユーザー"
      onClose={onClose}
      reactedEmployees={items}
      nextFetchFunction={fetchNextPage}
      hasMore={hasNextPage}
      isLoading={isLoading}
    />
  );
};
